import classNames from "classnames"
import { Button } from "primereact/button"
import { Dialog } from "primereact/dialog"
import { InputNumber } from "primereact/inputnumber"
import { InputTextarea } from "primereact/inputtextarea"
import React, { useState } from "react"
import { FaCheck, FaTimes } from "react-icons/fa"
import { toast } from "react-toastify"
import { InputNumberPague } from "../../../styles/primeReactConfig"
import { formatCurrency } from "../../../utils/formatCurrency"

function ContraPropostaDialog({ negotiateInfo, close, accept }) {

  const [valorContraProposta, setValorContraProposta] = useState(0);
  const [valorFeeProtesto, setValorFeeProtesto] = useState(0);
  const [valorFeePague, setValorFeePague] = useState(0);
  const [valorProvider, setValorProvider] = useState(0);
  const [parcelasContraProposta, setParcelasContraProposta] = useState(1);
  const [entrada, setEntrada] = useState(0)
  const [mensagemContraProposta, setMensagemContraProposta] = useState('')

  const footer = (
    <div className="flex justify-center gap-2 w-full">
      <Button
        label='Confirmar'
        icon={<FaCheck className="mr-2" />}
        severity="success"
        onClick={() =>
          criaContraProposta()
        }
      />
      <Button
        label="Cancelar"
        icon={<FaTimes className="mr-2" />}
        severity="danger"
        onClick={() => close()}
      />
    </div>
  )

  function criaContraProposta() {
    console.table({ valorContraProposta, entrada, parcelasContraProposta })
    if (parcelasContraProposta > 0) {
      if ((entrada === 0 || entrada > 33.25) && (((valorContraProposta - entrada) / parcelasContraProposta)) > 33.25) {
        accept({
          valorTotal: valorContraProposta,
          valorFeePague,
          valorFeeProtesto,
          valorProvider,
          entrada,
          parcelas: parcelasContraProposta,
          mensagem: mensagemContraProposta,
          proposta_id: negotiateInfo.proposta_id,
        })
      }
      else {
        toast.error('O valor do boleto a ser gerado não pode ser inferior a R$ 33,25')
      }
    }
    else
      toast.error('Insira o número de parcelas desejado')
  }

  function calculaDivisaoValores(valor_total, parcelas, entrada_proposta) {
    setValorContraProposta(valor_total)
    setEntrada(entrada_proposta)
    //console.table(negotiateInfo)
    if (entrada_proposta > 0) {
      const valor_restante = valor_total - entrada_proposta
      const valor_fee_pague_entrada = (((entrada_proposta) * 0.01) + negotiateInfo.fee_plataforma)
      const valor_fee_pague_restante = (((valor_restante / parcelas) * 0.01) + negotiateInfo.fee_plataforma) * parcelas
      const valor_fee_pague = valor_fee_pague_entrada + valor_fee_pague_restante
      const valor_fee_protesto = (valor_total - valor_fee_pague) * negotiateInfo.fee_proporcional
      setValorFeePague(valor_fee_pague)
      setValorFeeProtesto(valor_fee_protesto)
      setValorProvider(valor_total - valor_fee_protesto - valor_fee_pague)
    } else {
      const valor_fee_pague = (((valor_total / parcelas) * 0.01) + negotiateInfo.fee_plataforma) * parcelas
      const valor_fee_protesto = (valor_total - valor_fee_pague) * negotiateInfo.fee_proporcional
      setValorFeePague(valor_fee_pague)
      setValorFeeProtesto(valor_fee_protesto)
      setValorProvider(valor_total - valor_fee_protesto - valor_fee_pague)
    }
  }


  return (
    <Dialog
      visible
      onHide={() => close()}
      header="Fazer Contra-Proposta"
      footer={footer}
      pt={{
        root: 'max-w-screen lg:max-h-[80vh]',
        headerTitle: 'font-bold text-xl w-full text-center',
        content: ({ state }) => ({
          className: classNames('overflow-auto w-full max-h-[80vh]',
            'bg-white text-gray-700 px-6 pb-8 pt-0',
            //'rounded-bl-lg rounded-br-lg',
            'dark:bg-gray-900 dark:text-white/80 ', {
            "grow": state.maximized
          })
        }),
      }}
    >
      <div className="text-center flex-col md:flex-row flex gap-4 w-full">
        <div className="grid gap-3">
          <div className="flex flex-col">
            <h6><b>Valor Contra-Proposta: </b></h6>
            <InputNumber
              value={valorContraProposta}
              max={negotiateInfo.valorTotal}
              onValueChange={(e) => {
                calculaDivisaoValores(e.value, parcelasContraProposta, entrada)
              }
              }
              pt={InputNumberPague}
              placeholder="Valor da Contra-Proposta"
              id="valor"
              required
              mode="currency"
              currency="BRL"
              min={0}
            />
          </div>
          <div className="flex flex-col">
            <h6><b>Valor Entrada (opcional): </b></h6>
            <InputNumber
              value={entrada}
              max={valorContraProposta}
              onValueChange={(e) => {
                calculaDivisaoValores(valorContraProposta, parcelasContraProposta, e.value)
              }
              }
              pt={InputNumberPague}
              placeholder="Valor da Contra-Proposta"
              id="valor"
              required
              mode="currency"
              currency="BRL"
              min={0}
            />
          </div>
          <div className="flex flex-col">
            <h6><b>Nº de Parcelas: </b></h6>
            <InputNumber
              value={parcelasContraProposta}
              max={48}
              onValueChange={(e) => {
                setParcelasContraProposta(e.value);
                calculaDivisaoValores(valorContraProposta, e.value, entrada);
              }
              }
              pt={InputNumberPague}
              placeholder="N° de Parcelas"
              id="parcelas"
              required
              min={1}
            />
          </div>
          <div className="flex flex-col">
            <h6><b>Mensagem ao cliente: </b></h6>
            <InputTextarea
              value={mensagemContraProposta}
              onChange={(e) => setMensagemContraProposta(e.target.value)}
            />
          </div>
        </div>
        <div className="rounded-md border-2 bg-rose-100 dark:bg-rose-900 p-4" >
          <h5><b>Valor Total:</b> {formatCurrency(negotiateInfo.valorTotal)}</h5>
          <h5><b>Valor Proposto:</b> {formatCurrency(valorContraProposta)}</h5>
          <h5><b>Diferença:</b> {formatCurrency(negotiateInfo.valorTotal - valorContraProposta)}</h5>
          <h5><b>Valor Direto:</b> {formatCurrency(valorFeeProtesto)}</h5>
          <h5><b>Taxa Boleto:</b> {formatCurrency(valorFeePague)}</h5>
          <h5><b>Valor a Receber:</b> {formatCurrency(valorProvider)}</h5>
          {entrada > 0 && <h5><b>Entrada:</b> {formatCurrency(entrada)}</h5>}
          <h5><b>Número de Parcelas:</b> {entrada > 0 && '1 + '} {parcelasContraProposta}</h5>
        </div>
      </div>
    </Dialog>
  )
}

export default ContraPropostaDialog